import { useState, useEffect } from 'react'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59,
  })

  useEffect(() => {
    const getDeadline = () => {
      const stored = localStorage.getItem('alphafit_deadline')
      if (stored) {
        return parseInt(stored, 10)
      }
      // Set new deadline 23h 59m 59s from now
      const newDeadline = Date.now() + (23 * 3600 + 59 * 60 + 59) * 1000
      localStorage.setItem('alphafit_deadline', newDeadline.toString())
      return newDeadline
    }

    let deadline = getDeadline()

    const updateTimer = () => {
      const diff = deadline - Date.now()

      if (diff <= 0) {
        // Reset timer
        localStorage.removeItem('alphafit_deadline')
        deadline = getDeadline()
        return
      }

      setTimeLeft({
        hours: Math.floor(diff / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      })
    }

    updateTimer()
    const interval = setInterval(updateTimer, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
